export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/rent-parking/index/resources/computed.js